import { render } from "./SchoolLicenseManageValidTable.vue?vue&type=template&id=a8d67aa6&scoped=true"
import script from "./SchoolLicenseManageValidTable.vue?vue&type=script&lang=js"
export * from "./SchoolLicenseManageValidTable.vue?vue&type=script&lang=js"

import "./SchoolLicenseManageValidTable.vue?vue&type=style&index=0&id=a8d67aa6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8d67aa6"]])

export default __exports__